export default __webpack_public_path__ + "static/cod-screen-f53ba7082531d35a2e455edeaf51fc6b.png";